import styled, { css } from 'styled-components';

import { TableHeader } from '~/components/table/table-header/TableHeader';

import { PinConfig } from '../table-cell/TableCell';

export const StickyStyledTableHeader = styled(TableHeader)<{
  $pinConfig?: PinConfig;
  $size?: number;
}>`
  padding: 6px 12px;
  border-bottom: 1px solid var(--border-default);
  z-index: var(--z-index-header-cell);
  position: sticky;
  left: 0;
  top: 0;

  ${({ $size }) =>
    $size &&
    css`
      width: ${$size}px;
    `}

  ${({ $pinConfig }) =>
    $pinConfig &&
    css`
      position: sticky;
      z-index: calc(var(--z-index-header-cell) + 1);
      left: ${$pinConfig.left}px;
      right: ${$pinConfig.right}px;
      top: 0;
    `}

  ${({ $pinConfig }) =>
    $pinConfig?.isLastPinned &&
    css`
      border-right: 1px solid var(--border-default);
    `}
`;

export const StickyContentContainer = styled.div<{
  $size?: number;
}>`
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ $size }) =>
    $size &&
    css`
      width: ${$size - 24}px;
    `}
`;
